import { WreToolkitLibModule } from 'wre-toolkit-lib';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsComponent } from './fields-wrapper/fields/fields.component';
import { FieldsWrapperComponent } from './fields-wrapper/fields-wrapper.component';
import { EditModalWrapperComponent } from './fields-wrapper/edit-modal-wrapper/edit-modal-wrapper.component';
import { EditModalComponent } from './fields-wrapper/edit-modal-wrapper/edit-modal/edit-modal.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafrOverviewWrapperComponent } from './safr-overview-wrapper/safr-overview-wrapper.component';
import { SafrOverviewModalWrapperComponent } from './safr-overview-wrapper/safr-overview-modal-wrapper/safr-overview-modal-wrapper.component';
import { SafrOverviewAccessModalComponent } from './safr-overview-wrapper/safr-overview-modal-wrapper/safr-overview-access-modal/safr-overview-access-modal.component';
import { SafrOverviewAccessTableComponent } from './safr-overview-wrapper/safr-overview-access-table/safr-overview-access-table.component';
import { OverviewAccessModule } from '../overview-access/overview-access.module';
import { EditReviewerComponent } from './fields-wrapper/edit-modal-wrapper/edit-reviewer/edit-reviewer.component';
import { EditFieldComponent } from './fields-wrapper/edit-modal-wrapper/edit-field/edit-field.component';
import { FieldOptionsTableComponent } from './fields-wrapper/edit-modal-wrapper/edit-field/field-options-table/field-options-table.component';
import { DetailSidebarComponent } from './fields-wrapper/detail-sidebar-wrapper/detail-sidebar/detail-sidebar.component';
import { DetailHistoryTabComponent } from './fields-wrapper/detail-sidebar-wrapper/detail-history-tab/detail-history-tab/detail-history-tab.component';
import { FieldHistoryComponent } from './fields-wrapper/detail-sidebar-wrapper/field-history/field-history/field-history.component';
import { FieldHistoryCardComponent } from './fields-wrapper/detail-sidebar-wrapper/field-history-card/field-history-card/field-history-card.component';
import { FieldHistoryDataTableComponent } from './fields-wrapper/detail-sidebar-wrapper/field-history-data-table/field-history-data-table/field-history-data-table.component';


@NgModule({
  declarations: [
    FieldsComponent,
    FieldsWrapperComponent,
    EditModalWrapperComponent,
    EditModalComponent,
    SafrOverviewWrapperComponent,
    SafrOverviewModalWrapperComponent,
    SafrOverviewAccessModalComponent,
    SafrOverviewAccessTableComponent,
    EditReviewerComponent,
    EditFieldComponent,
    FieldOptionsTableComponent,
    DetailSidebarComponent,
    DetailHistoryTabComponent,
    FieldHistoryComponent,
    FieldHistoryCardComponent,
    FieldHistoryDataTableComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    SharedModule,
    WreToolkitLibModule,
    NgbModule,
    OverviewAccessModule
  ],
  exports: [
    FieldsWrapperComponent,
    FieldsComponent
  ]
})
export class SafrAdminModule { }
